import { FieldType, ViewModelBase, observable } from "@shoothill/core";
import { action, runInAction, computed } from "mobx";
import { RAMSReviewListAndRelatedDTO, RAMSReviewListModel } from "./RAMSReviewListModel";
import { AppUrls } from "AppUrls";

export class RAMSReviewListViewModel extends ViewModelBase<any> {
    handleRowClick(e: React.MouseEvent<Element, MouseEvent> | undefined, rowData: RAMSReviewListModel) {
        if (rowData) {
            const url: string = AppUrls.Client.Project.RAMSReview.View.replace(":projectid", this.projectId).replace(":ramsId", rowData.id);

            this.history.push(url);
        }
    }
    public projectId: string = "";

    @observable public RAMSReviewListModels: RAMSReviewListModel[] = [];

    constructor() {
        super();
    }

    @computed
    public get RAMSReviewListItems() {
        const list = this.RAMSReviewListModels.sort((a, b) => {
            const dateA = a.createdDate ? new Date(a.createdDate) : null;
            const dateB = b.createdDate ? new Date(b.createdDate) : null;

            if (dateA && dateB) {
                return dateB.getTime() - dateA.getTime();
            } else if (dateA) {
                return -1;
            } else if (dateB) {
                return 1;
            } else {
                return 0;
            }
        });
        return list;
    }

    @action
    public addRAMSReviewForm = () => {
        this.history.push(AppUrls.Client.Project.RAMSReview.Add.replace(":projectid", this.projectId));
    };

    @action
    public loadRAMSListItemsAndRelated = async (): Promise<void> => {
        this.setIsLoading(true);
        const request: any = {
            id: this.projectId,
            dateFilter: null,
        };
        let apiResult = await this.Post<RAMSReviewListAndRelatedDTO>(AppUrls.Server.Projects.Construction.Rams.GetRAMSAndRelated, request);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    // this.dilapidationTypes.replace(DilapidationTypesLookupModel.fromDtos(apiResult.payload.dilapidationReportTypes));
                    this.RAMSReviewListModels = [];
                    for (const RAMSReview of apiResult.payload.ramsListItems) {
                        let model = new RAMSReviewListModel();
                        model.fromDto(RAMSReview);
                        this.RAMSReviewListModels.push(model);
                    }
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
    };

    public async isFieldValid(fieldName: keyof FieldType<any>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
